<template>
  <div class="contact-page">
    <div class="contact-header">
      <h1>CONTACTEZ-NOUS</h1>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/contact">Contact</a>
      </div>
    </div>
    <div class="contact-content">
      <div class="contact-info">
        <h2>Approche</h2>
        <!-- Intégration de Google Maps pour l'adresse spécifique -->
        <div class="map-container">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d25623.568722439293!2d-7.5883094!3d33.5757493!3m2!1i1024!2i768!4f13.1!2m1!1s12%20Bd%20Hassan%20Al%20Alaoui%20R%C3%A9s.%20Nissrine%20%E2%80%93%20Ain%20Borja%2C%20Casablanca.!5e1!3m2!1sfr!2sma!4v1725041306677!5m2!1sfr!2sma" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            width="100%" 
            height="300" 
            frameborder="0" 
            style="border:0;" 
            allowfullscreen="" 
            aria-hidden="false" 
            tabindex="0">
          </iframe>
        </div>
    
        <ul>
          <li><strong>Téléphone :</strong> +212 5 22 60 05 06 / +212 5 22 62 05 07</li>
          <li><strong>Email :</strong> info@supracare.ma</li>
          <li><strong>Horaires :</strong> Lundi à Vendredi: 08h30 - 12h30 </li>
          <li>Après midi : 14h30 - 18h30</li>
             <li>Samedi : 08h30 - 12h30</li>
        </ul>
      </div>
      <div class="contact-form">
        <h2>Contact</h2>
        <p>Vous pouvez nous contacter de la manière qui vous convient. Nous sommes disponibles par fax, e-mail ou téléphone. Vous pouvez également utiliser un formulaire de contact rapide ci-dessous ou vous rendre personnellement à notre bureau.

Envoyez-nous un e-mail pour toute question ou demande de renseignements ou utilisez nos coordonnées. Nous serons heureux de répondre à vos questions.</p>
     
<form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="name">Nom</label>
            <input type="text" id="name" v-model="form.name" required />
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="form.email" required />
          </div>
          <div class="form-group">
            <label for="message">Message</label>
            <textarea id="message" v-model="form.message" required></textarea>
          </div>
          <button type="submit">Envoyer</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    };
  },
  methods: {
    submitForm() {
      console.log("Formulaire soumis avec les données :", this.form);
      this.form.name = '';
      this.form.email = '';
      this.form.message = '';
    }
  }
};
</script>

<style scoped>
.contact-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 20px;
  border-radius: 30px; /* Augmentation du rayon pour une forme plus arrondie */
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15); /* Ombre plus douce */
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  background-color: #f9f9f9;
 
}

.contact-page::before {
  content: '';
  position: absolute;
  top: -10px; /* Déplacement pour donner un effet flottant */
  left: -10px;
  width: calc(100% + 20px); /* Extension pour aller au-delà des bordures */
  height: calc(100% + 20px);
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/contc.jpg');
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  opacity: 0.15; /* Plus de transparence pour un effet encore plus subtil */
  z-index: -1;
  border-radius: 50px; /* Bordures encore plus arrondies pour un effet organique */
}

.contact-header {
  text-align: center;
  margin-bottom: 60px; /* Espace augmenté pour une disposition plus aérée */
  font-size: 25px; /* Taille de police légèrement augmentée */
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  color: #383843;
}

.breadcrumb {
  font-size: 12px; /* Augmentation de la taille de la police pour une meilleure lisibilité */
  color: #7f8c8d;
}

.breadcrumb a {
  color: #4b2e56;
  text-decoration: none;
  font-family: 'Georgia', serif;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.contact-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 50px; /* Augmentation du gap pour une séparation plus visible */
  width: 100%;
}

.contact-form {
  flex: 1;
  min-width: 320px;
  padding: 40px;
  order: 1; /* Afficher à gauche */
}

.contact-info {
  flex: 1;
  min-width: 320px;
  padding: 40px;
  order: 2; /* Afficher à droite */
}

.contact-info h2, .contact-form h2 {
  font-size: 16px; /* Taille de police légèrement augmentée */
  margin-bottom: 25px; /* Augmentation de la marge pour un meilleur espacement */
  color: #34495e;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
}

.contact-info ul {
  list-style: none;
  padding: 0;
  font-size: 16px; /* Taille de police augmentée */
  line-height: 1;
  color: #34495e;
}

.contact-info ul li {
  margin-bottom: 20px; /* Augmentation de la marge pour un espacement plus agréable */
}

.contact-info ul li strong {
  color: #2c3e50;
  font-weight: 700;
}

.map-container {
  width: 100%;
  height: 350px; /* Augmentation de la hauteur pour un meilleur affichage */
  margin-bottom: 30px; /* Augmentation de la marge pour un meilleur espacement */
  border-radius: 20px; /* Bordures arrondies */
  overflow: hidden;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #080a0c;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
}

/* Pour changer la couleur de l'écriture des inputs text */
input[type="text"],
input[type="email"],
textarea {
  color: black; /* Change la couleur de l'écriture */
  width: 100%;
  padding: 15px; /* Conserve le padding actuel */
  border: 1px solid #090909;
  border-radius: 10px;
  font-size: 18px;
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
  transition: border-color 0.3s;
  opacity: 0.15;
}

/* Pour augmenter l'espace entre les inputs et le bouton "Envoyer" */
.form-group {
  margin-bottom: 20px; /* Augmente l'espace entre les inputs */
}

input[type="text"]:focus,
input[type="email"]:focus,
textarea:focus {
  border-color: #716f6f;
}

textarea {
  height: 160px;
  resize: vertical;
  
}

button {
  display: inline-block;
  padding: 10px 20px; /* Augmentation du padding pour un effet plus imposant */
  background-color: #05305b;
  color: #fff;
  border: none;
  border-radius: 10px; /* Bordures arrondies */
  cursor: pointer;
  font-size: 14px; /* Taille de police augmentée */
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  transition: background-color 0.3s, transform 0.2s;
  margin-bottom: 10px;
}


button:hover {
  background-color: #1ee750dd;
  transform: translateY(-3px); /* Légère augmentation du déplacement au hover */
}

button:active {
  transform: translateY(0);
}
</style>


